export default __webpack_public_path__ + "static/zeiss-d258c87d8958052a8ee7f462a5a6856b.png";